/* global elementorFrontend, jQuery */

(function ($) {
  "use strict";

  function breakTitleAfterDash($scope) {
    $scope
      .find(".custom-title-break-space .elementor-heading-title")
      .each(function () {
        var $title = $(this);
        var $target = $title.find("a").length ? $title.find("a") : $title;

        if ($target.data("breakApplied")) {
          return;
        }

        var html = $target.html();
        var match = html.match(/\s*[-–]\s*/);

        if (match) {
          var splitIndex = html.indexOf(match[0]) + match[0].length;
          var before = html.slice(0, splitIndex).trim();
          var after = html.slice(splitIndex).trim();
          $target.html(before + "<br>" + after);
        }

        $target.data("breakApplied", true);
      });
  }

  $(document).ready(function () {
    breakTitleAfterDash($(document));
  });

  $(window).on("elementor/frontend/init", function () {
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/global",
      function ($scope) {
        breakTitleAfterDash($scope);
      },
    );
  });
})(jQuery);
